import { CASE_STATUS_LABELS } from '../types/assessmentHistory.types';
import type { CaseStatus } from '../types/assessmentHistory.types';

type StatusBadgeProps = {
  status: CaseStatus;
};

export const StatusBadge = ({ status }: StatusBadgeProps) => {
  return (
    <span className="inline-flex items-center text-[10px] font-medium px-2 py-0.5 rounded-full dark:bg-white/[0.06] bg-gray-100 dark:text-white/60 text-gray-600 dark:border-white/[0.08] border border-gray-200">
      {CASE_STATUS_LABELS[status] ?? status}
    </span>
  );
};
